import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { ICONS } from '@/src/components/common/Elements/Icon/Icon';
import ActionButton from '@/src/components/project/Inbox2/Elements/ActionButton/ActionButton';
import { FileEntry } from '@/src/components/project/Inbox2/types';
import { usePopper } from '@/src/hooks/usePopper';
import {
  showForm,
  initialize as initializeTaskPanel,
} from '@/src/reducers/tasks/taskForm/taskForm.actions';

import CreateTaskList from '../../../../Common/InfoPanel/CreateTask/CreateTaskList/CreateTaskList';
import { useFileEntryViewerSidebarActions } from '../../../store/fileEntryViewer.sidebarActions.store';

type CreateTaskProps = {
  fileEntry: FileEntry;
};

const CreateTask = ({ fileEntry }: CreateTaskProps) => {
  const { sidebarActions } = useFileEntryViewerSidebarActions();
  const { taskLinkKey, onTaskCreated, onTaskUpdated, onTaskDeleted, linkId } =
    sidebarActions.createTask;
  const [isPopperOpen, popperAnchorEl, togglePopper] = usePopper({ anchorEl: null, open: false });
  const dispatch = useDispatch();
  const taskList = fileEntry.tasks || [];
  const hasTaskList = taskList.length > 0;

  const handleMouseEnter = (e) => {
    togglePopper(e);
  };

  const handleMouseLeave = () => {
    togglePopper(null);
  };

  const handleOpenTaskForm = useCallback(async () => {
    await dispatch(
      showForm(
        {
          linkId,
          linkKey: taskLinkKey,
        },
        {
          customSuccessToastEnabled: true,
          onCreate: onTaskCreated,
          onUpdate: onTaskUpdated,
          onDelete: onTaskDeleted,
        }
      )
    );

    $('#task-form').modal('show');
  }, [linkId, taskLinkKey, dispatch, onTaskCreated, onTaskUpdated, onTaskDeleted]);

  const handleOpenTaskPanel = useCallback(
    async (taskId) => {
      await dispatch(
        initializeTaskPanel(taskId, {
          onUpdate: onTaskUpdated,
          onDelete: onTaskDeleted,
        })
      );
      $(`#task-details`).modal('show');
    },
    [dispatch, onTaskUpdated, onTaskDeleted]
  );

  const handleOpenTask = (taskId) => {
    handleOpenTaskPanel(taskId);
  };

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <ActionButton
        id={'create_task'}
        className={hasTaskList && 'tw-text-cfo-blue-700'}
        onClick={handleOpenTaskForm}
        icon={ICONS.create_task}
        tooltipSettings={{
          content: 'Create Task',
          place: 'left',
        }}
      />

      {hasTaskList && (
        <CreateTaskList
          open={isPopperOpen}
          anchorEl={popperAnchorEl}
          onShowCreateTaskModal={handleOpenTaskForm}
          taskList={taskList}
          onOpenTask={handleOpenTask}
        />
      )}
    </div>
  );
};

export default CreateTask;
